<template>
	<div class="refundOrder-body">
		<div class="shop-position">
			<img src="~/images/icon/position-icon.png">
			当前卖家店铺：
			<el-select size="mini" v-model="shopid" placeholder="请选择" @change="shopChange">
				<el-option
				v-for="item in shopOptions"
				:key="item.shopId"
				:label="item.shopName"
				:value="item.shopId"/>
			</el-select>
		</div>
		<Search ref="search" @handleSearch="handleSearch"/>
		<div class="btn-box">
			<el-button v-if="AuthorityList['10_0001_0001_00']" style="float:left;" size='mini' type='primary' @click="downloadClick" plain>
				导出
			</el-button>
			<el-button @click="reLoad" style="float:left;margin-left:20px" size='mini' type='primary' plain>
				刷新
			</el-button>
		</div>
		<div class="main-table">
		<div class="main-table-box">
			<el-table
				ref="table"
				class="grid-content"
				:data="tableData"
				border
				size='mini'
				stripe
				@sort-change = 'sortChangeHandle'
				:height="tableHeight">
				<el-table-column
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
					sortable='sort'
					:formatter='productnameFormatter'
					prop="productname"
					label="商品名称"
					align="center"
					min-width="200">
				</el-table-column>
				<el-table-column
					sortable='sort'
					:formatter='ordernumberFormatter'
					prop="ordernumber"
					label="订单编号"
					align="center"
					min-width="200">
				</el-table-column>
				<el-table-column
					sortable='sort'
					:formatter='createdate'
					prop="createdate"
					label="下单时间"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					:formatter='receivedate'
					sortable='sort'
					prop="receivedate"
					label="收货时间"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					:formatter='settlementdate'
					sortable='sort'
					prop="settlementdate"
					label="收款时间"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					:formatter='singleprice'
					sortable='sort'
					prop="singleprice"
					label="成交单价"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					sortable='sort'
					:formatter='commission'
					prop="commission"
					label="抽佣比例(‰)"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					:formatter='sendquantity'
					sortable='sort'
					prop="sendquantity"
					label="收货量"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					:formatter='sendmoney'
					sortable='sort'
					prop="sendmoney"
					label="商品小计"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					:formatter='sellermoney'
					sortable='sort'
					prop="sellermoney"
					label="商家实际收款"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					:formatter='paycommoney'
					sortable='sort'
					prop="paycommoney"
					label="支付手续费"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					sortable='sort'
					:formatter='commissionmoney'
					prop="commissionmoney"
					label="平台分佣"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					sortable='sort'
					:formatter='paymentstatusFormatter'
					prop="paymentstatus"
					label="收款状态"
					align="center"
					min-width="180">
					<template slot-scope="scope">
						<span v-if="scope.row.paymentstatus === 2" style="color:#bfbfbf">待收款</span>
						<span v-if="scope.row.paymentstatus === 0" style="color:#ff6081">收款中</span>
						<span v-if="scope.row.paymentstatus === 1" style="color:var(--fx-primary-color)">已收款</span>
					</template>
				</el-table-column>
				<el-table-column v-if="AuthorityList['10_0001_0002_00']"  label="操作" width="120" fixed='right' align="center">
					<template slot-scope="scope">
						<el-button v-if="scope.row.paymentstatus === 0 || scope.row.paymentstatus === 2" type='text' size="mini" @click="checkClick(scope.row)">查询入账</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="page.num"
			:page-sizes="[20,40, 60, 100]"
			:page-size="page.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</div>
	</div>
</template>

<script>
import Search from '@/components/settlement/Search.vue'
export default {
	name: 'refundOrder',
	components: {
		Search
	},
	data () {
		return {
			AuthorityList: {
				'10_0001_0001_00': false,
				'10_0001_0002_00': false
			},
			orderby: '',
			orderSort: null,
			dateValue: [],
			ordernumber: '',
			productname: '',
			datetype: 0,
			paymentstatus: -1,
			shopid: '',
			tableHeight: '100%',
			shopOptions: [],
			page: {
				num: 1,
				size: 20
			},
			total: 0,
			tableData: []
		}
	},
	created () {
		this.getAuthority('10_0001_0000_00')
		this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
		this.findShopList().then((data) => {
			if (data.length > 0) {
				this.shopid = data[0].shopId
				this.shopOptions = data
				this.tableReload()
			}
		})
	},
	methods: {
		downloadClick () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.urlQIV}/shop/order/settlementCenter/exportExcel?shopid=` + this.shopid, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send()
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			let name = '结算管理' + year + '-' + month + '-' + day + '.xls'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		checkClick (row) {
			let params = {
				orderid: row.orderid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/detail/settlementCenter/refreshfinishflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('查询成功')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		paymentstatusFormatter (row, column, cellValue, index) {
			return cellValue
		},
		productnameFormatter (row, column, cellValue, index) {
			return cellValue
		},
		ordernumberFormatter (row, column, cellValue, index) {
			return cellValue
		},
		commissionmoney (row, column, cellValue, index) {
			return this.$fxUtils.toFixedSHW(cellValue, 2)
		},
		commission (row, column, cellValue, index) {
			return this.$fxUtils.toFixedSHW(cellValue, 2)
		},
		paycommoney (row, column, cellValue, index) {
			return this.$fxUtils.toFixedSHW(cellValue, 2)
		},
		createdate (row, column, cellValue, index) {
			return cellValue
		},
		receivedate (row, column, cellValue, index) {
			return cellValue
		},
		settlementdate (row, column, cellValue, index) {
			return cellValue
		},
		sendquantity (row, column, cellValue, index) {
			return cellValue
		},
		singleprice (row, column, cellValue, index) {
			return this.$fxUtils.toFixedSHW(cellValue, 2)
		},
		sendmoney (row, column, cellValue, index) {
			return this.$fxUtils.toFixedSHW(cellValue, 2)
		},
		sellermoney (row, column, cellValue, index) {
			return this.$fxUtils.toFixedSHW(cellValue, 2)
		},
		sortChangeHandle (data) {
			this.orderby = data.prop
			if (data.order === 'ascending') {
				this.orderSort = 0
			}
			if (data.order === 'descending') {
				this.orderSort = 1
			}
			if (data.order === null) {
				this.orderSort = null
			}
			this.tableReload()
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		shopChange () {
			this.orderby = ''
			this.orderSort = null
			this.page = {
				num: 1,
				size: 20
			}
			this.tableReload()
		},
		reLoad () {
			this.orderby = ''
			this.orderSort = null
			this.$refs.search.clear()
		},
		tableReload () {
			let params = {
				orderSort: this.orderSort,
				orderby: this.orderby,
				startDate: this.dateValue[0],
				endDate: this.dateValue[1],
				shopId: this.shopid,
				page: this.page.num,
				size: this.page.size,
				ordernumber: this.ordernumber,
				productname: this.productname,
				datetype: this.datetype,
				paymentstatus: this.paymentstatus
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/settlementCenter/list`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data.data
					this.total = res.data.count
					this.$refs.table.doLayout()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSearch (data) {
			this.page = {
				num: 1,
				size: 20
			}
			this.orderby = ''
			this.orderSort = null
			this.dateValue = data.dateValue
			this.ordernumber = data.ordernumber
			this.productname = data.productname
			this.datetype = data.datetype
			this.paymentstatus = data.paymentstatus
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.num = val
			this.tableReload()
		},
		handleSizeChange (val) {
			this.page.num = 1
			this.page.size = val
			this.tableReload()
		}
	}
}
</script>

<style lang="stylus" scoped>
.refundOrder-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.btn-box{
		border-top:1px solid #dce2fd;
		padding-top :10px;
		height :40px;
		line-height :40px;
		width :100%;
	}
    .main-table {
        display flex
        flex: 1
        flex-direction: column
        height: 100%
        .main-table-box {
            flex: 1
            height: 100%
            padding-bottom 10px
            overflow-y: auto;
        }
    }
}
</style>

